import { Reveal } from "@/components/landing/Reveal";

const TAGS = ["Mindful spending", "Financial literacy", "Social awareness"];

export const About = () => {
  return (
    <section id="about" className="scroll-mt-20 bg-splurge-ink py-24 lg:py-32">
      <div className="mx-auto max-w-7xl px-5 sm:px-8">
        <Reveal>
          <p className="text-xs font-extrabold uppercase tracking-[0.22em] text-splurge-violet">
            The goal
          </p>
        </Reveal>
        <Reveal delay={80}>
          <h2 className="mt-4 max-w-4xl text-4xl font-extrabold leading-[1.08] tracking-tight text-white sm:text-5xl lg:text-6xl">
            Financial awareness should feel{" "}
            <span className="bg-gradient-to-r from-splurge-violet to-splurge-lavender bg-clip-text text-transparent">
              empowering, not restrictive.
            </span>
          </h2>
        </Reveal>
        <Reveal delay={160}>
          <p className="mt-8 max-w-2xl text-base leading-relaxed text-white/60 md:text-lg">
            Built by{" "}
            <span className="font-bold text-white">Ranvirr Pardasani</span> and{" "}
            <span className="font-bold text-white">Rajveer Agrawal</span>, Splurge is helping a
            new generation understand peer pressure, group spending, and the financial impact of
            everyday social choices.
          </p>
        </Reveal>
        <Reveal delay={240}>
          <ul className="mt-10 flex flex-wrap gap-3" data-testid="about-principles">
            {TAGS.map((tag) => (
              <li
                key={tag}
                className="rounded-full border border-white/15 bg-white/5 px-5 py-2.5 text-sm font-bold text-splurge-lavender backdrop-blur-sm transition-colors duration-300 hover:border-splurge-violet/60 hover:bg-splurge-primary/20"
              >
                {tag}
              </li>
            ))}
          </ul>
        </Reveal>
      </div>
    </section>
  );
};
